import { ScrollingLogos } from '../../../js/src/__utils/sliders';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        ScrollingLogos.init();
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
